var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 65,
    viewBox: "0 0 68 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0156 0L39.6504 22.2993L60.5979 12.8013L46.6769 31.1102L67.1632 41.5657L44.1692 42.0972L48.7677 64.6329L34.0156 46.9868L19.2636 64.6329L23.8621 42.0972L0.868076 41.5657L21.3544 31.1102L7.43336 12.8013L28.3808 22.2993L34.0156 0Z",
    fill: "#8F8FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGlow);
export default __webpack_public_path__ + "static/media/logo-glow.7bd8c5ab8392028963b0ef7aeeefa09c.svg";
export { ForwardRef as ReactComponent };